e4.gtm = {
    debug: false,
    init: function () {
        if ( window.dataLayer !== undefined ) {
            e4.gtm.bindEvents();
        }
        else {
            e4.util.debug( [
                'window.google_tag_manager = ',
                window.google_tag_manager,
                'Not binding anything.'
            ], e4.gtm.debug );
        }
    },
    bindEvents: function () {
        jQuery( document )
        .on( 'userauthenticated.e4.login', e4.gtm.login )
        .on( 'productadded.e4.cart', e4.gtm.ecom.addProduct )
        .on( 'productremoved.e4.cart', e4.gtm.ecom.removeProduct );
        jQuery( '.js-e-search-form' )
        .on( 'getresult.e4.search', e4.gtm.search );
    },
    pushDataLayer: function ( objDataLayer ) {
         //console.log( objDataLayer )
        if ( window.dataLayer !== undefined ) {
            dataLayer.push( objDataLayer );
        }
    },
    login: function () {
        //New GA4 
        e4.gtm.pushDataLayer( {
            'event': 'login',
            'method': 'email'
        } );
        
        e4.gtm.pushDataLayer( {
            'LoggedOn': 'OK',
            'event': 'LoggedOnDone'
        } );
    },
    search: function ( event, data ) {
        //New GA4
        e4.gtm.pushDataLayer( {
            'event': 'search',
            'search_term': data.query
        } );
        if ( data.resultCount === 0 ) {
            e4.gtm.pushDataLayer( {
                'ga4EventName': 'Zero-search',
                'ga4EventParameter1': data.query,
                'event': 'track-ga4-event'
            } );
        }
        
        e4.gtm.pushDataLayer( {
            'event': 'VirtualPageviewSearch',
            'virtualPageSearchURL': '/search?q=' + data.query,
            'virtualPageSearchTitle': 'Search'
        } );
        if ( data.resultCount === 0 ) {
            e4.gtm.pushDataLayer( {
                'eventCategory': 'Nulsøgning',
                'eventAction': data.query,
                'eventLabel': '{{Page URL}}',
                'eventValue': 0,
                'eventInteraction': true,
                'event': 'track-ga-event'
            } );
        }
    },
    ecom: {
        // https://developers.google.com/tag-manager/enhanced-ecommerce#cart
        addProduct: function ( event, data ) {
            //GA4 - NEW
            e4.gtm.pushDataLayer({
                event: "add_to_cart",
                ecommerce: {
                    items: [
                        {
                            item_id: data.cart.lastAdded[ 0 ].number,
                            item_name: data.cart.lastAdded[ 0 ].name,
                            currency: data.cart.currencyCode,
                            price: data.cart.lastAdded[ 0 ].priceClean,
                            quantity: data.cart.lastAdded[ 0 ].quantity
                        }
                    ]
                }
            });
            
            // console.log( 'GTM: Add product', data );
            var lastAddedProductArr = [];
            for ( var i = 0; i < data.cart.lastAdded.length ; i++ ) {
                lastAddedProductArr.push(
                        {
                            name: data.cart.lastAdded[i].name,
                            id: data.cart.lastAdded[i].number,
                            price: data.cart.lastAdded[i].priceClean,
                            quantity: data.cart.lastAdded[i].quantity
                        }
                );
            }
            e4.gtm.pushDataLayer( {
                event: 'addToCart',
                ecommerce: {
                    currencyCode: data.cart.currencyCode,
                    add: {
                        products: lastAddedProductArr
                    }
                }
            } );
        },
        removeProduct: function ( event, data ) {
            //GA4 - NEW
            console.log()
            e4.gtm.pushDataLayer( {
                event: "remove_from_cart",
                ecommerce: {
                    items: [
                        {
                            item_id: data.number,
                            item_name: data.name,
                            currency: data.currencyCode,
                            price: data.priceClean,
                            quantity: data.quantity
                        }
                    ]
                }
            } );
            
            //console.log( 'GTM: Remove product', data );
            e4.gtm.pushDataLayer( {
                'event': 'removeFromCart',
                'ecommerce': {
                    currencyCode: data.currencyCode,
                    'remove': {
                        'products': [ {
                            name: data.name,
                            id: data.number,
                            price: data.priceClean,
                            quantity: data.quantity
                        } ] 
                    }
                }
            } );
        }
    }
};
